import React, { useEffect } from 'react';
import s from './ChatPanel.module.css';
import chatLogo from './../../../assets/img/Chat/chatLogo.jpeg';
import { useSelector } from 'react-redux';
import Message from './Message/Message';


const ChatPanel = ({onSendNewMessage}, ...props) => {
    const {chatRoomName, messages, members} = useSelector(({chat}) => chat);

    const messagesContainer = React.createRef();

    useEffect(() => {
        messagesContainer.current.scrollTop = messagesContainer.current.scrollHeight
    }, [props, messagesContainer]);


    const messagesList = messages.map(message => (
        <Message key={message.uuid} 
            content={message.content} 
            sender={members.find(member => member.uuid === message.sender_id)}/>
    ));

    const inputMessageRef = React.createRef();

    const sendMessageHandler = () => {
        const message = inputMessageRef.current.value;
        if(message.length > 0) {
            onSendNewMessage(message);
            inputMessageRef.current.value = '';
        }
    }

    return (
        <div className={s.chatPanel}>
            <header className={s.chatHeader}>
                <div className={s.chatInfo}>
                    <div className={s.chatLogo}>
                        <img src={chatLogo} alt="chat image"/>
                    </div>
                    <div className={s.chatTitle}>{chatRoomName}</div>
                </div>
            </header>
            <div ref={messagesContainer} className={s.messagesBlock}>
                {messagesList}
            </div>
            <div className={s.inputMessage}>
                <div className={s.inputBtns}>smile, docs</div>
                <textarea ref={inputMessageRef} type="text" placeholder="Type your message"/>
                <button onClick={sendMessageHandler} className={s.btnSend}>Send</button>
            </div>
        </div>
    )
}

export default ChatPanel
